import {Injectable} from '@angular/core';
import {ToastrService} from "ngx-toastr";

@Injectable({
    providedIn: 'root'
})
export class NotificationService {

    constructor(private toastrService: ToastrService) {
    }

    public showSuccess(title: string, message: string) {
        this.toastrService.success(message, title, {timeOut: 8000})
    }

    public showError(title: string, message: string) {
        this.toastrService.error(message, title, {disableTimeOut: true});
    }

    public showInfo(title: string, message: string) {
        this.toastrService.info(message, title, {timeOut: 8000})
    }

    public showWarning(title: string, message: string) {
        this.toastrService.warning(message, title, {timeOut: 8000})
    }
}
